import { EmptyState, SearchInput, Table } from 'components';
import { CellsTypes } from 'constants/index';
import React, { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Profile } from 'types';

import {
  SidebarContent,
  SidebarContentWrapper,
  StyledSearchWrapper,
} from './styled';

interface EventDetailsParticipantsProps {
  users: Profile[];
  height?: string;
  admin?: string[];
  maxWidth?: string;
}

const EventDetailsParticipants: FC<EventDetailsParticipantsProps> = ({
  users = [],
  height,
  admin,
  maxWidth,
}) => {
  const { t } = useTranslation();
  const [filteredUsers, setUsers] = useState<Profile[]>(users);
  const [inputValue, setValue] = useState<string>('');
  const searchInputRef = useRef<HTMLDivElement>(null);

  const tableConfig = {
    title: t('community.members'),
    headers: [
      {
        id: 'name',
        width: '100%',
        type: CellsTypes.AVATAR_NAME,
        headerType: 'title',
      },
    ],
  };

  const handleChange = (text) => {
    const newMembers = users.filter(({ firstName, lastName }) =>
      `${firstName} ${lastName}`
        .toLocaleLowerCase()
        .includes(text.toLowerCase()),
    );
    setUsers(newMembers);
    setValue(text);
  };

  return (
    <SidebarContent height={height}>
      <StyledSearchWrapper ref={searchInputRef}>
        <SearchInput
          width="100%"
          value={inputValue}
          fillWidth={true}
          onChange={({ target }) => handleChange(target.value)}
        />
      </StyledSearchWrapper>
      <SidebarContentWrapper>
        {filteredUsers.length > 0 ? (
          <Table
            data={filteredUsers}
            config={tableConfig}
            search={inputValue}
            icon
            admin={admin}
            maxWidth={maxWidth}
          />
        ) : inputValue.trim() ? (
          <EmptyState
            icon="🔍"
            title={t('event.noParticipantsSearchResults.title')}
            description={t('event.noParticipantsSearchResults.description', {
              searchTerm: inputValue.trim(),
            })}
            onClearSearch={() => {
              handleChange('');
              if (searchInputRef.current) {
                const input = searchInputRef.current.querySelector('input');
                if (input) {
                  input.value = '';
                  input.dispatchEvent(new Event('input', { bubbles: true }));
                }
              }
            }}
          />
        ) : (
          <EmptyState
            icon="👥"
            title={t('event.noParticipants.title')}
            description={t('event.noParticipants.description')}
          />
        )}
      </SidebarContentWrapper>
    </SidebarContent>
  );
};

export default EventDetailsParticipants;
